module.exports = __webpack_public_path__ + "img/service-NDW3.1ce3e649.svg";